import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getAccountPublic, getBillingSummary, getCustomerLedger } from './api';

/** `org-account`: staff account changes invalidate this prefix, so an open order form follows a switch. */
export const ledgerKeys = {
  account: (organizationId: string) => ['org-account', organizationId] as const,
  summary: (organizationId: string) => ['org-account', organizationId, 'summary'] as const,
  history: (organizationId: string) => ['org-account', organizationId, 'history'] as const,
};

export const useAccountPublic = (organizationId: string, enabled = true) =>
  useQuery({
    queryKey: ledgerKeys.account(organizationId),
    queryFn: () => getAccountPublic(supabase, organizationId),
    enabled,
    staleTime: 60_000,
  });
export const useBillingSummary = (organizationId: string, enabled = true) =>
  useQuery({
    queryKey: ledgerKeys.summary(organizationId),
    queryFn: () => getBillingSummary(supabase, organizationId),
    enabled,
  });
export const useCustomerLedger = (organizationId: string, enabled = true) =>
  useQuery({
    queryKey: ledgerKeys.history(organizationId),
    queryFn: () => getCustomerLedger(supabase, organizationId),
    enabled,
  });
